export default __webpack_public_path__ + "static/media/visa-saving-edge.bbfbdfaf.png";